<template>
  <div class="boss-page" @click="handleOverviewClick">
    <header class="boss-header" style="height:46px;justify-content:center;text-align:center"><span>首页</span></header>
    <section class="panel bubble-panel">
      <div class="date-switcher" @click.stop>
        <button type="button" aria-label="前一天" @click="shiftDate(-1)">
          <van-icon name="arrow-left"/>
        </button>
        <span>{{ dateBanner }}</span>
        <button type="button" aria-label="后一天" @click="shiftDate(1)">
          <van-icon name="arrow"/>
        </button>
      </div>
      <h3>今日日志提交率</h3>
      <div class="bubbles">
        <div v-for="u in displayUnits" v-if="u.businessUnit.indexOf('文化')<0" :key="u.businessUnit" class="bubble-item"
             :class="bubbleClass(u.businessUnit)+(u.businessUnit.indexOf('传媒')>=0?' media':'')">
          <div class="bubble"><b>{{ Math.round(u.submissionRate || 0) }}<small>%</small></b></div>
          <span>{{ unitShortName(u.businessUnit) }}</span></div>
      </div>
    </section>
    <section class="panel"><h3>今日考核平均分（按事业部）</h3>
      <div v-for="u in units.filter(v=>v.businessUnit!=='全部'&&v.businessUnit.indexOf('市场')<0&&v.businessUnit.indexOf('文化')<0)"
           :key="u.businessUnit+'score'" class="bar-row"><span>{{ u.businessUnit }}</span>
        <div class="bar" :class="bubbleClass(u.businessUnit)"><i :style="{width:Math.min(100,u.averageScore||0)+'%'}"></i></div>
        <b>{{ Number(u.averageScore || 0).toFixed(1) }}分</b></div>
    </section>
    <section class="panel sales-panel"><h3>销售业绩完成情况<small v-if="trendFallbackLabel" class="trend-note">{{ trendFallbackLabel }}</small></h3>
      <div v-if="salesTrend.length" class="line-chart"
           @mousemove="onChartPointer" @touchmove.prevent="onChartPointer"
           @mouseleave="hideTooltip" @touchend="hideTooltip">
        <div v-if="tooltip.visible" class="chart-tooltip" :style="tooltipStyle">
          <div class="tip-date">{{ tooltipDateLabel }}</div>
          <div v-for="item in tooltipItems" :key="item.name" class="tip-row">
            <i :style="{background:item.color}"></i>
            <span>{{ item.name }}</span>
            <b>{{ formatMoney(item.value) }}</b>
          </div>
        </div>
        <svg ref="chartSvg" viewBox="0 0 360 170">
          <line x1="42" y1="10" x2="42" y2="140" stroke="#9aa1b2"/>
          <line x1="42" y1="140" x2="350" y2="140" stroke="#9aa1b2"/>
          <text x="5" y="16" class="axis-label">累计回款（元）</text>
          <text x="325" y="162" class="axis-label">日期</text>
          <text x="8" y="143" class="tick">0</text>
          <text x="5" y="28" class="tick">{{ maxRevenueLabel }}</text>
          <line v-if="tooltip.visible" :x1="activePointX" y1="10" :x2="activePointX" y2="140" class="guide-line"/>
          <polyline v-for="line in trendSeries" :key="line.name" :points="line.polyline" fill="none"
                    :stroke="line.color" stroke-width="3" stroke-linejoin="round"/>
          <circle v-for="dot in activeDots" :key="dot.name" :cx="dot.x" :cy="dot.y" r="4.5"
                  :fill="dot.color" stroke="#fff" stroke-width="1.5"/>
          <text v-for="idx in axisTickIndexes" :key="'tick-'+chartDates[idx]" :x="chartX(idx)" y="154"
                class="tick date-tick">{{ formatAxisDate(chartDates[idx]) }}</text>
        </svg>
        <div class="legend"><span v-for="line in trendSeries" :key="line.name"><i
          :style="{background:line.color}"></i>{{ line.name }}</span></div>
      </div>
      <p v-else class="empty">暂无财务审核通过的销售回款</p></section>
    <div class="entries">
      <button @click="$router.push('/efficiency/boss/all-worklogs')">日志综合榜</button>
      <button @click="$router.push('/boss/ability-cards')">人员能力卡片<br><small>左右滑动切换</small></button>
    </div>
    <div class="entries">
      <button @click="$router.push('/boss/department-data')">部门数据<br><small>按部门维度</small></button>
      <button @click="$router.push('/boss/customer-data')">客户数据<br><small>按客户维度</small></button>
    </div>
  </div>
</template>
<style scoped>
.boss-header {
  font-size: 16px !important;
  font-weight: 500 !important
}

.date-switcher {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -4px 0 10px;
  color: #666d7c;
  font-size: 14px;
  background: #f1f2f5;
  border-radius: 6px
}

.date-switcher button {
  width: 38px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #777f8e;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center
}

.date-switcher span {
  flex: 1;
  text-align: center;
  white-space: nowrap
}

.bubble-panel .bubbles {
  display: flex;
  justify-content: space-between;
  gap: 3px;
  overflow: visible
}

.bubble-panel .bubble-item {
  min-width: 0;
  flex: 1;
  text-align: center
}

.bubble-panel .bubble {
  width: clamp(46px, 14vw, 56px);
  height: clamp(46px, 14vw, 56px);
  margin: 0 auto;
  border-width: 2px
}

.bubble-panel .bubble b {
  font-size: 23px
}

.bubble-panel .bubble b small {
  font-size: 10px
}

.bubble-panel .bubble-item > span {
  margin-top: 6px;
  font-size: 11px;
  white-space: nowrap
}

.bubble-panel, .boss-page > .panel:nth-of-type(2) {
  cursor: pointer
}
</style>

<style scoped>
.bubble-item.media {
  color: #2697e8
}

.bar.media i {
  background: #2697e8
}
</style>
<script>
import coreapi from '@/utils/coreapi';

const SALES_UNITS = ['安全事业部', '健康事业部', '传媒事业部'];
const UNIT_COLORS = {
  '安全事业部': '#e32b32',
  '健康事业部': '#18a957',
  '传媒事业部': '#2697e8'
};

export default {
  name: 'BossHomeOverview', data() {
    const now = new Date();
    const localDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return {
      date: localDate,
      units: [],
      trend: [],
      salesTrendMonth: '',
      activeIndex: -1,
      tooltip: {visible: false}
    }
  }, computed: {
    salesTrend() {
      return this.trend.filter(p => SALES_UNITS.includes(p.businessUnit))
    },
    trendFallbackLabel() {
      if (!this.salesTrend.length || !this.salesTrendMonth) return '';
      const current = this.date.slice(0, 7);
      if (this.salesTrendMonth === current) return '';
      const parts = this.salesTrendMonth.split('-');
      if (parts.length < 2) return '';
      return `展示${parts[0]}年${Number(parts[1])}月（当月暂无数据）`;
    },
    displayUnits() {
      return this.units.filter(v => v.businessUnit.indexOf('市场') < 0 && v.businessUnit.indexOf('院长') < 0 && v.businessUnit.indexOf('品牌') < 0)
    }, dateBanner() {
      const d = new Date(`${this.date}T00:00:00`);
      return `${this.date} ${['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][d.getDay()]}`
    }, chartDates() {
      return [...new Set(this.salesTrend.map(p => String(p.date)))].sort()
    }, axisTickIndexes() {
      const n = this.chartDates.length;
      if (!n) return [];
      if (n <= 6) return [...Array(n).keys()];
      const target = Math.min(6, Math.max(4, Math.round(n / 5)));
      const indexes = [0];
      const step = (n - 1) / (target - 1);
      for (let i = 1; i < target - 1; i++) indexes.push(Math.round(i * step));
      if (indexes[indexes.length - 1] !== n - 1) indexes.push(n - 1);
      return [...new Set(indexes)].sort((a, b) => a - b);
    }, maxRevenue() {
      return Math.max(...this.salesTrend.map(p => Number(p.value || 0)), 1)
    }, maxRevenueLabel() {
      return Math.round(this.maxRevenue).toLocaleString('zh-CN')
    }, trendSeries() {
      const groups = {};
      SALES_UNITS.forEach(u => { groups[u] = {} });
      this.salesTrend.forEach(p => { groups[p.businessUnit][String(p.date)] = Number(p.value || 0) });
      return SALES_UNITS.map(name => {
        let last = 0;
        const points = this.chartDates.map((d, i) => {
          if (groups[name][d] != null) last = groups[name][d];
          const x = this.chartX(i);
          const y = 140 - (last / this.maxRevenue) * 120;
          return {date: d, value: last, x, y};
        });
        return {
          name,
          color: UNIT_COLORS[name],
          points,
          polyline: points.map(p => `${p.x},${p.y}`).join(' ')
        };
      });
    }, activePointX() {
      if (this.activeIndex < 0 || !this.chartDates.length) return 0;
      return this.chartX(this.activeIndex);
    }, activeDots() {
      if (!this.tooltip.visible || this.activeIndex < 0) return [];
      return this.trendSeries.map(line => ({
        name: line.name,
        color: line.color,
        x: line.points[this.activeIndex].x,
        y: line.points[this.activeIndex].y
      }));
    }, tooltipItems() {
      if (this.activeIndex < 0) return [];
      return this.trendSeries.map(line => ({
        name: line.name,
        color: line.color,
        value: line.points[this.activeIndex].value
      }));
    }, tooltipDateLabel() {
      if (this.activeIndex < 0) return '';
      const d = this.chartDates[this.activeIndex];
      if (!d) return '';
      const parts = d.split('-');
      return parts.length >= 3 ? `${parts[1]}-${parts[2]}` : d;
    }, tooltipStyle() {
      const left = Math.min(78, Math.max(8, (this.activePointX / 360) * 100));
      return {left: `${left}%`};
    }
  }, created() {
    this.load()
  }, methods: {
    formatLocalDate(d) {
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    }, shiftDate(delta) {
      const d = new Date(`${this.date}T00:00:00`);
      d.setDate(d.getDate() + delta);
      this.date = this.formatLocalDate(d);
      this.load()
    }, handleOverviewClick(event) {
      const panel = event.target.closest && event.target.closest('.panel');
      if (!panel) return;
      if (panel.classList.contains('bubble-panel')) {
        this.$router.push({ name: 'EfficiencyAllWorklogs', query: { date: this.date } });
        return
      }
      const title = panel.querySelector('h3');
      if (title && title.textContent.indexOf('今日考核平均分') >= 0) this.$router.push({
        name: 'BossLogRankings',
        query: {dimension: 'BUSINESS_UNIT', date: this.date}
      })
    }, unitShortName(name) {
      return name.indexOf('健康') >= 0 ? '健康' : name.indexOf('安全') >= 0 ? '安全' : name.indexOf('文化') >= 0 ? '文化' : name.indexOf('总经') >= 0 ? '总经办' : name === '全部' || name.indexOf('全公司') >= 0 ? '全部' : name.slice(0, 2)
    }, chartX(index) {
      return 42 + index * 308 / Math.max(this.chartDates.length - 1, 1)
    }, formatAxisDate(date) {
      const parts = String(date).split('-');
      return parts.length >= 3 ? `${parts[1]}-${parts[2]}` : String(date).slice(5);
    }, formatMoney(value) {
      return `${Math.round(Number(value || 0)).toLocaleString('zh-CN')}元`;
    }, onChartPointer(event) {
      if (!this.chartDates.length) return;
      const svg = this.$refs.chartSvg;
      if (!svg || !svg.getBoundingClientRect) return;
      const rect = svg.getBoundingClientRect();
      const clientX = event.touches && event.touches.length ? event.touches[0].clientX : event.clientX;
      const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      const viewX = 42 + ratio * 308;
      let best = 0;
      let bestDist = Infinity;
      this.chartDates.forEach((_, i) => {
        const dist = Math.abs(this.chartX(i) - viewX);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      this.activeIndex = best;
      this.tooltip.visible = true;
    }, hideTooltip() {
      this.tooltip.visible = false;
      this.activeIndex = -1;
    }, bubbleClass(n) {
      return n === '安全事业部' ? 'safe' : n === '健康事业部' ? 'health' : n === '文化事业部' ? 'culture' : n === '总经办' ? 'hq' : 'all'
    }, async load() {
      try {
        const d = await coreapi.bossHomeOverview(this.date);
        this.units = [d.overall, ...(d.units || [])];
        this.trend = d.salesTrend || [];
        this.salesTrendMonth = d.salesTrendMonth || this.date.slice(0, 7);
        this.hideTooltip();
      } catch (e) {
        this.$toast && this.$toast(e.message || '服务调用失败')
      }
    }
  }
};
</script>
<style scoped>.boss-page {
  min-height: 100vh;
  background: #f6f7fb;
  color: #303133;
  padding-bottom: 3rem
}

.boss-header {
  height: 58px;
  background: linear-gradient(90deg, #26191b, #c9272c);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 21px
}

.date {
  text-align: center;
  background: #fff;
  padding: 12px;
  color: #777
}

.bubbles {
  display: flex;
  justify-content: space-around;
  gap: 8px;
  padding: 8px 0;
  overflow-x: auto
}

.bubble-item {
  min-width: 70px;
  text-align: center;
  color: #666
}

.bubble {
  width: 66px;
  height: 66px;
  background: #fff;
  border: 3px solid currentColor;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center
}

.bubble b {
  font-size: 27px;
  line-height: 1;
  color: inherit;
  background: transparent
}

.bubble b small {
  font-size: 13px;
  background: transparent
}

.bubble-item > span {
  display: block;
  font-size: 12px;
  color: inherit;
  margin-top: 7px
}

.bubble-item.all {
  color: #666
}

.bubble-item.safe {
  color: #e32b32
}

.bubble-item.health {
  color: #18a957
}

.bubble-item.culture {
  color: #2697e8
}

.bubble-item.hq {
  color: #ff7b45
}

.panel {
  background: #fff;
  margin: 0 12px 12px;
  padding: 14px;
  border-radius: 8px
}

.panel h3 {
  margin: 0 0 14px;
  font-size: 16px
}

.trend-note {
  margin-left: 6px;
  color: #9298a8;
  font-size: 11px;
  font-weight: 400
}

.line-chart {
  position: relative;
  height: 210px;
  touch-action: none
}

.chart-tooltip {
  position: absolute;
  z-index: 2;
  top: 0;
  transform: translateX(-50%);
  min-width: 148px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(38, 25, 27, .92);
  color: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .18);
  pointer-events: none
}

.tip-date {
  margin-bottom: 6px;
  font-size: 11px;
  color: #d6d9e0
}

.tip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 11px
}

.tip-row i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none
}

.tip-row span {
  flex: 1
}

.tip-row b {
  font-size: 11px;
  font-weight: 600
}

.guide-line {
  stroke: #c0c6d4;
  stroke-width: 1;
  stroke-dasharray: 4 3
}

.bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
  font-size: 12px
}

.bar-row > span {
  width: 70px
}

.bar {
  flex: 1;
  height: 12px;
  background: #edf0f4;
  border-radius: 6px;
  overflow: hidden
}

.bar i {
  display: block;
  height: 100%;
  background: #d9272e;
  border-radius: 6px
}

.bar.safe i {
  background: #e32b32
}

.bar.health i {
  background: #18a957
}

.bar.culture i {
  background: #2697e8
}

.bar.hq i {
  background: #ff7b45
}

.bar-row b {
  width: 45px;
  text-align: right
}

.line-chart svg {
  width: 100%;
  height: 170px;
  display: block
}

.axis-label {
  font-size: 9px;
  fill: #697386
}

.tick {
  font-size: 8px;
  fill: #9aa1b2
}

.date-tick {
  text-anchor: middle
}

.legend {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 11px
}

.legend i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 3px
}

.empty {
  color: #9aa1b2
}

.entries {
  display: flex;
  gap: 12px;
  padding: 4px 12px 16px
}

.entries button {
  flex: 1;
  border: 0;
  border-radius: 8px;
  background: #d9272e;
  color: #fff;
  padding: 12px;
  font-size: 16px
}

.entries button.muted {
  background: #666
}

.entries small {
  font-size: 12px
}

.feature-link {
  margin: 0 12px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  color: #d9272e;
  display: flex;
  justify-content: space-between
}</style>



// WEBPACK FOOTER //
// src/views/boss/HomeOverview.vue